/* eslint-disable */

import React from "react";
import { useTranslation } from "react-i18next";

export default function CountrySelector() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  
  return (
    <div className="min-h-[420px] h-fit" dir={isRTL ? "rtl" : "ltr"}>
      <section className="relative max-w-screen-xl px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
              {t("servicePageActivation.countrySelectorDetails.title")}
              <span className="text-[#9e68ba] dark:text-purple-400"> {t("servicePageActivation.countrySelectorDetails.subtitle")} </span>
            </h3>
            
            <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
              {t("servicePageActivation.countrySelectorDetails.description")}
            </p>

            {/* المميزات الرئيسية */}
            <div className="bg-[#fcf6ff] dark:bg-purple-900/20 p-4 rounded-lg border border-[#fbf4ff] dark:!border-purple-800/30 mb-6">
              <h4 className="font-medium text-[#9e68ba] dark:text-purple-300 mb-3">
                {t("servicePageActivation.countrySelectorDetails.features.title")}
              </h4>
              <ul className="space-y-2 text-gray-700 dark:text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 dark:bg-purple-400 rounded-full mr-2"></span>
                  <strong className="dark:text-gray-100">
                    {t("servicePageActivation.countrySelectorDetails.features.items.0.text")}:
                  </strong>{" "}
                  <span className="dark:text-gray-300">
                    {t("servicePageActivation.countrySelectorDetails.features.items.0.description")}
                  </span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 dark:bg-purple-400 rounded-full mr-2"></span>
                  <strong className="dark:text-gray-100">
                    {t("servicePageActivation.countrySelectorDetails.features.items.1.text")}:
                  </strong>{" "}
                  <span className="dark:text-gray-300">
                    {t("servicePageActivation.countrySelectorDetails.features.items.1.description")}
                  </span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 dark:bg-purple-400 rounded-full mr-2"></span>
                  <strong className="dark:text-gray-100">
                    {t("servicePageActivation.countrySelectorDetails.features.items.2.text")}:
                  </strong>{" "}
                  <span className="dark:text-gray-300">
                    {t("servicePageActivation.countrySelectorDetails.features.items.2.description")}
                  </span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 dark:bg-purple-400 rounded-full mr-2"></span>
                  <strong className="dark:text-gray-100">
                    {t("servicePageActivation.countrySelectorDetails.features.items.3.text")}:
                  </strong>{" "}
                  <span className="dark:text-gray-300">
                    {t("servicePageActivation.countrySelectorDetails.features.items.3.description")}
                  </span>
                </li>
              </ul>
            </div>

            {/* فوائد الأعمال المحلية والدولية */}
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {/* فوائد للأعمال المحلية */}
              <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:!border-blue-800/30">
                <h4 className="font-semibold text-blue-800 dark:text-blue-300 mb-3 flex items-center">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-5 w-5 ml-2 text-blue-600 dark:text-blue-400" 
                    viewBox="0 0 20 20" 
                    fill="currentColor"
                  >
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z" clipRule="evenodd" />
                  </svg>
                  {t("servicePageActivation.countrySelectorDetails.localBusiness.title")}
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li className="flex items-start">
                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                    {t("servicePageActivation.countrySelectorDetails.localBusiness.items.0")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                    {t("servicePageActivation.countrySelectorDetails.localBusiness.items.1")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                    {t("servicePageActivation.countrySelectorDetails.localBusiness.items.2")}
                  </li>
                </ul>
              </div>

              {/* فوائد للأعمال الدولية */}
              <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-100 dark:!border-green-800/30">
                <h4 className="font-semibold text-green-800 dark:text-green-300 mb-3 flex items-center">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-5 w-5 ml-2 text-green-600 dark:text-green-400" 
                    viewBox="0 0 20 20" 
                    fill="currentColor"
                  >
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd" />
                  </svg>
                  {t("servicePageActivation.countrySelectorDetails.internationalBusiness.title")} 
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 dark:text-green-400 ml-2">•</span>
                    {t("servicePageActivation.countrySelectorDetails.internationalBusiness.items.0")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 dark:text-green-400 ml-2">•</span>
                    {t("servicePageActivation.countrySelectorDetails.internationalBusiness.items.1")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 dark:text-green-400 ml-2">•</span>
                    {t("servicePageActivation.countrySelectorDetails.internationalBusiness.items.2")}
                  </li>
                </ul>
              </div>
            </div>

            {/* كيفية العمل */}
            <div className="bg-gray-50 dark:bg-gray-800/50 p-5 rounded-lg border border-gray-200 dark:!border-gray-700 mb-6">
              <h4 className="font-semibold text-gray-800 dark:text-gray-200 mb-4 flex items-center">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 ml-2 text-gray-600 dark:text-gray-400" 
                  viewBox="0 0 20 20" 
                  fill="currentColor"
                >
                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                </svg>
                {t("servicePageActivation.countrySelectorDetails.howItWorks.title")}
              </h4>

              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 rounded-full w-6 h-6 flex items-center justify-center ml-3 flex-shrink-0 text-sm font-bold">
                    1
                  </div>
                  <div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                      {t("servicePageActivation.countrySelectorDetails.howItWorks.steps.0.title")}
                    </h5>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      {t("servicePageActivation.countrySelectorDetails.howItWorks.steps.0.description")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 rounded-full w-6 h-6 flex items-center justify-center ml-3 flex-shrink-0 text-sm font-bold">
                    2
                  </div>
                  <div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                      {t("servicePageActivation.countrySelectorDetails.howItWorks.steps.1.title")}
                    </h5>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      {t("servicePageActivation.countrySelectorDetails.howItWorks.steps.1.description")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 rounded-full w-6 h-6 flex items-center justify-center ml-3 flex-shrink-0 text-sm font-bold">
                    3
                  </div>
                  <div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                      {t("servicePageActivation.countrySelectorDetails.howItWorks.steps.2.title")}
                    </h5>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      {t("servicePageActivation.countrySelectorDetails.howItWorks.steps.2.description")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* حالات الاستخدام */}
            <div className="mb-8">
              <h4 className="font-semibold text-gray-800 dark:text-gray-200 mb-4">
                {t("servicePageActivation.countrySelectorDetails.useCases.title")}
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Case 1 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-blue-500 dark:bg-blue-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.countrySelectorDetails.useCases.cases.0.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.countrySelectorDetails.useCases.cases.0.description")}
                  </p>
                </div>

                {/* Case 2 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-green-500 dark:bg-green-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.countrySelectorDetails.useCases.cases.1.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.countrySelectorDetails.useCases.cases.1.description")}
                  </p>
                </div>

                {/* Case 3 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-purple-500 dark:bg-purple-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.countrySelectorDetails.useCases.cases.2.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.countrySelectorDetails.useCases.cases.2.description")}
                  </p>
                </div>

                {/* Case 4 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-orange-500 dark:bg-orange-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.countrySelectorDetails.useCases.cases.3.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.countrySelectorDetails.useCases.cases.3.description")}
                  </p>
                </div>
              </div>
            </div>

            {/* نصائح للاستخدام */}
            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:!border-yellow-800/30 rounded-lg p-4">
              <h4 className="font-semibold text-yellow-800 dark:text-yellow-300 mb-3 flex items-center">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 ml-2 text-yellow-600 dark:text-yellow-400" 
                  viewBox="0 0 20 20" 
                  fill="currentColor"
                >
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
                {t("servicePageActivation.countrySelectorDetails.tips.title")} 
              </h4>
              <ul className="text-sm text-yellow-700 dark:text-yellow-300 space-y-2">
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.countrySelectorDetails.tips.items.0")} 
                </li>
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.countrySelectorDetails.tips.items.1")}
                </li>
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.countrySelectorDetails.tips.items.2")}
                </li>
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.countrySelectorDetails.tips.items.3")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}